import authorizedEmails from '../../data/authorizedEmails';

export default function hasAuthorizedEmailForProduction(user: any): boolean {
  return authorizedEmails.productionUsers.includes(
    String(user?.primaryEmailAddress?.emailAddress)
  );
}
